export const REDUX_STORE_HOME = 'add_instagram_source'
